import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from '../login/login.component'
import { ContractListComponent } from '../contract-list/contract-list.component'
import { ContractComponent } from '../contract/contract.component'
import { PendingChangesGuard } from "../contract/contract.guard";
import { WizardComponent } from "../wizard/wizard.component";
import { AppContainer } from "../app-container/app.container";
import { TOA } from "../toa/toa";
import { DataNote } from "../data-note/data-note";
import { Privacy } from "../privacy/privacy";


const routes: Routes = [
    {
        path: '',
        component: AppContainer,
        children: [
            {
                path: '',
                component: ContractListComponent,
            },
            {
                path: 'contract',
                component: ContractComponent,
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: 'contract/:id',
                component: ContractComponent,
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: 'wizard',
                component: WizardComponent,
            },
            {
                path: 'toa',
                component: TOA,
            },
            {
                path: 'privacy',
                component: Privacy,
            },
            {
                path: 'data-note',
                component: DataNote,
            },
        ]
    },

];

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    providers: [PendingChangesGuard],
    exports: [
        RouterModule
    ],
    declarations: []
})

export class AppRoutingModule { }


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/app-routing/app-routing.module.ts